import { InjectionToken } from '@angular/core';
import { FuturesGateway } from './futures-gateway.interface';

export const FUTURES_GATEWAY = new InjectionToken<FuturesGateway>(
  'futures-gateway',
);
